import React, { CSSProperties } from 'react';
import classNames from 'classnames';

interface ComponentProps {
  status: {
    id: number;
    name: string;
    colour: string;
  };
  changed?: boolean;
}

const StatusStrip: React.FC<ComponentProps> = ({ status, changed = false }) => {
  const { colour, name } = status;

  const style: CSSProperties = {
    backgroundColor: colour ?? 'yellow',
  };

  const classnames = classNames('status-strip', {
    changed,
  });

  return <div className={classnames} title={name} style={style} />;
};

export default StatusStrip;
